import { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";

/**
 * Image de pochette avec :
 * - placeholder couleur d'accent pendant le chargement
 * - fallback automatique sur le logo de la radio en cas d'erreur
 * - gestion du cas "déjà en cache" (onLoad qui ne se déclenche pas)
 */
export function RadioCardImage({ cover, fallback, accent, alt, isPlaceholder }) {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    setLoaded(false);
    const img = imgRef.current;
    if (img && img.complete && img.naturalWidth > 0) {
      setLoaded(true);
    }
  }, [cover]);

  const handleError = (e) => {
    if (e.currentTarget.src !== fallback) {
      e.currentTarget.src = fallback;
    }
  };

  return (
    <>
      <img
        ref={imgRef}
        src={cover}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={loaded ? "rh-img-ready" : "rh-img-loading"}
        onLoad={() => setLoaded(true)}
        onError={handleError}
        style={{ background: accent }}
      />
      {!loaded && !isPlaceholder && (
        <div className="rh-card-skel">
          <Loader2 size={20} className="rh-spin" />
        </div>
      )}
    </>
  );
}
